export const MOVEMENT_TYPES_BG = {
  SAIDA: "danger",
  ENTRADA: "success",
};

export const MOVEMENT_TYPES = [
  {
    label: "ENTRADA",
    value: "ENTRADA",
  },
  {
    label: "SAÍDA",
    value: "SAIDA",
  },
  {
    label: "ENTRADA CANCELADA",
    value: "ENTRADA_C",
  },
  {
    label: "SAÍDA CANCELADA",
    value: "SAIDA_C",
  },
  {
    label: "TRANSFERÊNCIA",
    value: "TRANSF",
  },
  {
    label: "DEVOLUÇÃO",
    value: "DEVOLUC_C",
  },
  {
    label: "ENTRADA E SAÍDA DEVOLUÇÃO",
    value: "ENTRADA_SAIDA_DEVOLUCAO",
  },
];

export const LIMIT_ROWS_OPTIONS = [
  {
    label: "10",
    value: 10,
  },
  {
    label: "20",
    value: 20,
  },
  {
    label: "40",
    value: 40,
  },
  {
    label: "60",
    value: 60,
  },
  {
    label: "80",
    value: 80,
  },
  {
    label: "100",
    value: 100,
  },
];
